import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Card, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import InfoIcon from '@mui/icons-material/Info';
import { useAuth } from '../../contexts/AuthContext';
import { usePost } from '../../apis/ApiRequests';
import { format } from 'date-fns';
import HeaderMobile from './components/Header';

const FishingStatusMobile = () => {

    const { authInfo } = useAuth();
    const navigate = useNavigate();

    const today = format(new Date(), 'yyyyMMdd');
    const todayDisplay = format(new Date(), 'yyyy-MM-dd');

    //-----------------------------------------------
    // initialize - セッション情報を取得
    //-----------------------------------------------
    const facilityCode = authInfo.facilityCode;
    const userId       = authInfo.userId;

    //-----------------------------------------------
    // initialize - useState
    //-----------------------------------------------
    const [ searchCount, setSearchCount ] = useState(0);
    const [ dataGridHeight, setDataGridHeight ] = useState(window.innerHeight - 280);

    //===============================================
    // API
    //===============================================
    //-----------------------------------------------
    // API - getDataMethodList / table.PortSchedule
    //-----------------------------------------------
    const { response: getDataMethodList_res, post: getDataMethodList_post } = usePost();
    const getDataMethodList = async () => {
        const postData = {
            'className'    : 'mch.models.table.PortSchedule',
            'methodName'   : 'getDataMethodList',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'targetDate'   : today
        }
        await getDataMethodList_post(postData);
    };

    //-----------------------------------------------
    // API - searchData / masta.FishMethod
    //-----------------------------------------------
    const { response: getDataAll_fishMethod_res, post: getDataAll_fishMethod_post } = usePost();
    const getDataAll_fishMethod = async () => {
        const postData = {
            'className'    : 'mch.models.masta.FishMethod',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
        }
        await getDataAll_fishMethod_post(postData);
    };

    //===============================================
    // useEffect
    //===============================================
    //-----------------------------------------------
    // useEffect - ロード時の設定
    //-----------------------------------------------
    useEffect(() => {
        const handleResize = () => {
            setDataGridHeight(window.innerHeight - 280);
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    //-----------------------------------------------
    // useEffect - 検索処理
    //-----------------------------------------------
    useEffect(() => {
        getDataMethodList();
        getDataAll_fishMethod();
    }, [searchCount]);

    //===============================================
    // JSXのレンダー
    //===============================================
    const header_date = {
        marginLeft   : '0px',
        marginRight  : '20px',
        padding      : '7px 10px 5px 10px',
        height       : '47px',
        borderRadius : '10px',
        color        : '#305496',
        fontSize     : '22px',
        width        : '100%',
        fontWeight   : 'bold'
    };

    const emptyMessageContainer = {
        backgroundColor: 'orange',
        color: '#fff',
        fontSize: '20px',
        border: '1px solid #fff',
        borderRadius: '10px',
        padding: '10px',
        width: '100%',
        marginBottom: '10px',
    };

    const externalEvents = (getDataMethodList_res?.Data ?? []).map(data => ({
        id: data.methodCode,
        name: getDataAll_fishMethod_res?.Data?.find(item => item.code === data.methodCode)?.displayName ?? "",
        count: data.senmeiCount,
    }));

    return (
        <>
            <HeaderMobile />
            <div className='bidList bodyContens' style={{ marginTop: '60px' }}>
                <div style={header_date}>{ todayDisplay }の出漁状況</div>
                <div style={{ marginTop: '1em', width: '100%', height: dataGridHeight, marginBottom: '10px', overflowY: 'scroll' }}>
                    {externalEvents.length === 0 ? (
                        <div style={emptyMessageContainer}>
                            出漁情報は登録されていません
                        </div>
                    ) : (
                        <Card variant="outlined" sx={{ overflow: 'hidden' }}>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, ml: 2, py: 1 }}>
                                {externalEvents.map((method) => {
                                    const methodName = `${method.name}(${method.count})`;
                                    return (
                                        <Typography key={method.id} variant="subtitle2" sx={{ fontWeight: 700, fontSize: '1.2em', textAlign: "left" }}>
                                            {methodName}
                                        </Typography>
                                    );
                                })}
                            </Box>
                        </Card>
                    )}
                </div>
            </div>
            <div style={{ position: 'fixed', left: 0, bottom: 0, width: '100%', color: 'white', textAlign: 'center' }}>
                <Button
                    color     = "secondary"
                    size      = "large"
                    style     = {{ fontSize: '20px', width: '90%', marginBottom: '1rem', color: '#fff' }}
                    variant   = "contained"
                    startIcon = {<RefreshIcon />}
                    onClick   = {() => { setSearchCount(searchCount + 1) }}
                >
                最新情報を読み込む
                </Button>
                <Button
                    color     = "secondary"
                    size      = "large"
                    style     = {{ fontSize: '20px', width: '90%', marginBottom: '1rem', color: '#fff', backgroundColor: 'grey' }}
                    variant   = "contained"
                    startIcon = {<InfoIcon />}
                    onClick   = {() => { navigate('/homeMobile') }}
                >
                ホームへ戻る
                </Button>
            </div>
        </>
    );
}

export default FishingStatusMobile;
